module.exports = __webpack_public_path__ + "1a4083663e9761908c7aeea5c52a98e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/night-sky-s.png
// module id = 2399
// module chunks = 0